export default __webpack_public_path__ + "static/media/lorenivy_small.5556bd5a.jpg";